var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createEffect } from "effector/effector.cjs";
export function FetchRequestFx(repo) {
    const fetchRequest = createEffect({
        handler: (id) => {
            return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                const response = yield repo.fetch(id);
                resolve(response.result);
            }));
        }
    });
    return fetchRequest;
}
//# sourceMappingURL=FetchRequestFx.js.map